/* SANIKB hero v11 — [Claude 2026-09-29] upgrade of the v9 original ([Claude 2026-09-24], the version the boss chose).
   Tour per fixture: rim light traces the fixture's silhouette → the next model is queued in the picker →
   the fixture itself changes in the room (image layer + new rim + sweep) → hold → next fixture / next room.
   v11 fixes (audit 2026-09-29): race-safe layer swaps (a newer pick always wins, old and new cross-fade together),
   room changes that can be cancelled and never act on the old room, picker text/keyboard/thumbnail fixes,
   hover holds that cannot get stuck, camera framed to the visible stage, stable headline, single-step tour swaps,
   outlines refreshed when a basin changes, doors below the fixtures they enclose, tour progress from the real schedule. */
(() => {
  'use strict';
  const D = window.SANIKB_HERO_V9;
  if (!D || !D.scenes) return;
  // [ChatGPT 2026-10-01] Shopify locale strings; model IDs, image geometry and scheduling stay shared.
  let I = {};
  try { I = JSON.parse(document.getElementById('skv11-i18n')?.textContent || '{}'); } catch (_) {}
  // Shopify t escapes non-_html locale values, including values subsequently serialized with json.
  // Decode once before textContent / DOM attributes; _html values retain their intentional markup/entities.
  const textDecoder = document.createElement('textarea');
  Object.keys(I).forEach(key => { if (typeof I[key] === 'string' && !key.endsWith('_html')) { textDecoder.innerHTML = I[key]; I[key] = textDecoder.value; } });
  const tr = (key, fallback, vars = {}) => String(I[key] || fallback).replace(/\{\{\s*(\w+)\s*\}\}|__sk_(\w+)__/g, (match, a, b) => { const name = a || b; return Object.prototype.hasOwnProperty.call(vars, name) ? String(vars[name]) : match; });
  const dataKeys = {"23-Inch Oval Ceramic Vessel Sink":"data_001","32\" Equal Double Bowl Undermount Stainless Steel Sink":"data_002","33×19 Black Quartz Farmhouse Workstation Sink":"data_003","48 × 32 Shower Base":"data_004","48 × 32 in":"data_005","48 × 36 Acrylic Shower Base":"data_006","48 × 36 in":"data_007","60 × 32 Acrylic Shower Base":"data_008","60 × 32 Apron Bathtub":"data_009","60 × 32 in":"data_010","60 × 36 Shower Base":"data_011","60 × 36 in · end drain":"data_012","Apartment kitchen":"data_013","Automatic Flush Smart Toilet":"data_014","Basins":"data_015","Bath faucets":"data_016","Bathtubs":"data_017","Black & rose gold":"data_018","Black Apron Front Fireclay Sink":"data_019","Black aluminum frame":"data_020","Black hose":"data_021","Black quartz":"data_022","Black quartz composite":"data_023","Black-apron fireclay":"data_024","Brushed Nickel Thermostatic Rain Shower System with Handheld & Shelf":"data_025","Brushed gold":"data_026","Brushed gold · concealed":"data_027","Brushed nickel":"data_028","Brushed nickel · concealed":"data_029","Brushed nickel · exposed":"data_030","Chrome":"data_031","Chrome Slim Pull-Down Kitchen Faucet with Squared Base":"data_032","Clear glass":"data_033","Comfort-Height One-Piece Toilet":"data_034","Comfort-height one-piece":"data_035","Commercial-Style Pull-Down Kitchen Faucet with Black Hose":"data_036","Compact Gloss White Oval Freestanding Tub, 58 in":"data_037","Compact One-Piece Toilet":"data_038","Compact Single Handle Bathroom Faucet":"data_039","Compact Slipper Soaking Tub, Freestanding, 51 in":"data_040","Compact one-piece":"data_041","Concrete":"data_042","Cylindrical Gooseneck Faucet":"data_043","Deep Round Drum Ceramic Vessel Sink with Overflow, 16.5\"":"data_044","Deep Single Bowl Undermount Sink":"data_045","Double Bowl Quartz Sink":"data_046","Double Sliding Shower Door":"data_047","Drop-in · 59 × 31 in":"data_048","Dual-Spout Swing-Arm Kitchen Faucet":"data_049","Dual-Spray Pull-Down Faucet":"data_050","Fine-fluted glass":"data_051","Fireclay":"data_052","Fireclay Farmhouse Workstation Sink":"data_053","Fixed Side Spout Kitchen Faucet with Spring-Coil Sprayer":"data_054","Fluted Corner Bathtub on Plinth Base, 59 in":"data_055","Fluted Double Sliding Door":"data_056","Fluted Rectangular Concrete Basin":"data_057","Fluted Round Concrete Basin":"data_058","Fluted corner · 59 × 30 in":"data_059","Fluted glass":"data_060","Frameless Double Sliding Door":"data_061","Freestanding oval · 58 × 30 in":"data_062","Grey concrete":"data_063","Hotel bathroom":"data_064","Hotel guest bathroom":"data_065","Hotel shower & bath":"data_066","Kitchen faucets":"data_067","Left basin":"data_068","Left faucet":"data_069","Low Lie-Down Walk-In Whirlpool Tub with Glass Door, 60 in":"data_070","Matte Black & Rose Gold Pull-Down Kitchen Faucet":"data_071","Matte Black Spring-Coil Pull-Down Kitchen Faucet":"data_072","Matte Black Thermostatic Shower System with Square Rain Head & Shelf":"data_073","Matte black":"data_074","Matte black · exposed":"data_075","Modern Seamless Dual-Flush Skirted Elongated One-Piece Toilet":"data_076","One-piece, concealed trapway":"data_077","One-piece, dual flush":"data_078","One-piece, single flush":"data_079","Rectangular Drop-In Acrylic Bathtub, Narrow Flat Flange, 59 in":"data_080","Reversible Fluted and Smooth Fireclay Workstation Sink, 33\"":"data_081","Right basin":"data_082","Right faucet":"data_083","Round Concrete Vessel Sink":"data_084","Round Rain Shower Set":"data_085","Rounded Rectangular Concrete Basin":"data_086","Serviced apartment kitchen":"data_087","Shower & bath":"data_088","Shower bases":"data_089","Shower doors":"data_090","Shower sets":"data_091","Single Sliding Fluted Shower Door":"data_092","Single-Flush Skirted Elongated One-Piece Toilet":"data_093","Sinks":"data_094","Skirted Elongated One-Piece Toilet with Concealed Trapway":"data_095","Skirted alcove · 60 × 32 in":"data_096","Slim Flat Spout Bathroom Faucet":"data_097","Slim Rectangular Ceramic Vessel Sink":"data_098","Slipper · 51 × 31 in":"data_099","Spring coil + side spout":"data_100","Spring-Coil Dual-Spout Faucet":"data_101","Square Rain Shower Set":"data_102","Square Single-Hole Faucet":"data_103","Stainless":"data_104","Stainless steel":"data_105","Tankless Smart Bidet Toilet":"data_106","Tankless, auto flush":"data_107","Tankless, bidet":"data_108","Toilets":"data_109","Walk-in · 60 × 30 in":"data_110","White ceramic":"data_111","White concrete":"data_112","White fireclay":"data_113","Wide Single-Bowl Stainless Steel Farmhouse Sink, 33x22x9":"data_114"};
  const localText = text => I[dataKeys[text]] || text;
  D.scenes.forEach(s => {
    s.name = localText(s.name); s.tag = localText(s.tag);
    if (s.jump) s.jump.label = localText(s.jump.label);
    s.groups.forEach(g => { g.label = localText(g.label); if (g.name) g.name = localText(g.name); });
  });
  Object.values(D.products).forEach(p => { p.title = localText(p.title); p.material = localText(p.material); });
  const localUrl = raw => {
    const root = String(I.root || '/').replace(/\/$/, '');
    if (!root) return raw; // preserve every English href exactly
    try { const url = new URL(raw, location.origin); return root + url.pathname + url.search + url.hash; } catch (_) { return raw; }
  };
  const [SW, SH] = D.size;
  const $ = id => document.getElementById(id);
  const hero = $('hero'), stage = $('stage'), frame = $('frame'), cam = $('cam'), liftRoot = $('liftGroups');
  const copy = $('copy'), veil = $('veil'), roomTag = $('roomTag'), tabsEl = $('roomTabs'), toggle = $('toggle');
  const headlineKeys = {hotel: 'headline_html', bath: 'headline_shower_html', apartment: 'headline_kitchen_html'};
  const headlineFallbacks = {"hotel": "Bathroom solutions <span class=\"h1-l2\">for builders &amp; project buyers.</span>", "bath": "Shower &amp; bath supply <span class=\"h1-l2\">for projects &amp; wholesalers.</span>", "apartment": "Kitchen sinks &amp; faucets <span class=\"h1-l2\">for builders &amp; wholesalers.</span>"};
  const picker = $('picker'), track = $('pkTrack'), dotsEl = $('dots'), jump = $('jump'), live = $('live'), rail = $('rail');
  const roomEls = [...document.querySelectorAll('.room[data-room]')];
  const NS = 'http://www.w3.org/2000/svg';
  const mqPhone = matchMedia('(max-width: 900px)');
  const mqCompact = matchMedia('(max-width: 1180px)');
  const DOCK = 20;   // the docked picker's distance from the photo's bottom-left corner
  const mqReduce = matchMedia('(prefers-reduced-motion: reduce)');
  const scenes = D.scenes, P = D.products;
  const T = {queue: 1500, swap: 2750, next: 6300, entryScan: 650, draw: 1800, manualHold: 14000, fade: 340};

  const defaults = s => Object.fromEntries(s.groups.map(g => [g.id, g.choices[0]]));
  const st = {
    room: 0, target: 0, pending: false, forceManual: false, token: 0, focusToken: 0, first: true,
    playing: !mqReduce.matches, reduced: mqReduce.matches, inView: true,
    held: new Set(), sel: {}, group: {}, visits: {}, swapped: new Set(),
    layout: null, pickerPos: null, tourIdx: 0, groupClock: 0
  };
  scenes.forEach(s => { st.sel[s.id] = defaults(s); st.group[s.id] = s.tour[0]; st.visits[s.id] = 0; });
  const scene = () => scenes[st.room];
  const groupOf = (s, id) => s.groups.find(g => g.id === id);
  const wait = ms => new Promise(r => setTimeout(r, st.reduced ? Math.min(ms, 60) : ms));
  const pad = n => String(n).padStart(2, '0');
  const clamp = (v, lo, hi) => Math.min(hi, Math.max(lo, v));
  const union = (a, b) => [Math.min(a[0], b[0]), Math.min(a[1], b[1]), Math.max(a[2], b[2]), Math.max(a[3], b[3])];

  // Shower sets and bases sit behind the enclosure: with a fluted or framed door they cannot be shown or outlined crisply.
  const behindDoor = (s, gid) => { const r = D.rules[s.id]; return !!r && (gid === 'shower-sets' || gid === 'bases') && st.sel[s.id][r.exclusive] !== r.clearDoor; };
  // v12 [Claude 2026-09-29]: each visit of a room tours one plan (visits alternate between the room's plans). Linked
  // groups (a tap on its basin / sink, a fluted door over the shower set) are never in the same plan, so every tour
  // step changes exactly one product and nothing has to be put back.
  const plansOf = s => (s.plans && s.plans.length ? s.plans : [s.tour]);
  const planOf = (s, visit = st.visits[s.id]) => { const P = plansOf(s); return P[(Math.max(1, visit) - 1) % P.length]; };
  const tourCount = (s, gid, visit) => { const P = plansOf(s); let c = 0; for (let v = 1; v <= visit; v++) if (P[(v - 1) % P.length].includes(gid)) c++; return c; };
  // Auto entry: the other groups at their defaults; each toured group starts one model before this visit's model,
  // so each tour swap is a single picker step.
  function entryState(s, visit) {
    // groups this visit does not tour keep what they showed before (hotel: the basins stay when the faucets are toured)
    const sel = visit > 1 ? {...st.sel[s.id]} : defaults(s);
    planOf(s, visit).forEach(gid => {
      const g = groupOf(s, gid), n = g.choices.length, c = Math.max(1, tourCount(s, gid, visit)) + (g.tourOffset || 0);
      sel[gid] = n > 1 ? g.choices[(c - 1) % (n - 1)] : g.choices[0];
    });
    // a kept product that a toured group would put back (linked tap/sink, a fluted door over the shower set / base)
    // starts at its default, so no tour step changes two products
    const plan = planOf(s, visit), r0 = D.rules[s.id] || {}, dflt = gid => groupOf(s, gid).choices[0];
    (r0.links || []).forEach(([a, b]) => { if (plan.includes(a) && !plan.includes(b)) sel[b] = dflt(b); if (plan.includes(b) && !plan.includes(a)) sel[a] = dflt(a); });
    if (r0.exclusive && plan.includes(r0.exclusive)) s.groups.forEach(g => { if (g.id !== r0.exclusive && g.id !== 'tubs' && !plan.includes(g.id)) sel[g.id] = dflt(g.id); });
    if (r0.exclusive && !plan.includes(r0.exclusive) && plan.some(g => g !== 'tubs')) sel[r0.exclusive] = r0.clearDoor;
    fixCombos(s, sel, plan);
    const r = D.rules[s.id];
    if (r && r.exclusive && sel[r.exclusive] !== r.clearDoor) s.groups.forEach(g => { if (g.id !== r.exclusive && g.id !== 'tubs') sel[g.id] = g.choices[0]; });
    return sel;
  }
  const nextChoice = (s, g) => g.choices[(g.choices.indexOf(st.sel[s.id][g.id]) + 1) % g.choices.length];

  /* ------------------------------------------------------------ holdable tour clock */
  const clock = {t: null, fn: null, due: 0, left: 0};
  const held = () => !st.playing || st.held.size > 0 || document.hidden || !st.inView;
  function after(ms, fn) {
    clearTimeout(clock.t); clock.t = null; clock.fn = fn; clock.left = ms;
    if (!held()) { clock.due = performance.now() + ms; clock.t = setTimeout(fire, ms); }
  }
  function fire() { const fn = clock.fn; clock.fn = null; clock.t = null; if (fn) fn(); }
  function cancelTour() { st.tourGen = (st.tourGen || 0) + 1; clearTimeout(clock.t); clock.t = null; clock.fn = null; picker.querySelector('.is-queued')?.classList.remove('is-queued'); }
  function syncHold() {
    const h = held();
    hero.classList.toggle('is-held', h);
    if (h && clock.t) { clearTimeout(clock.t); clock.t = null; clock.left = Math.max(0, clock.due - performance.now()); }
    if (!h && clock.fn && !clock.t) { clock.due = performance.now() + clock.left; clock.t = setTimeout(fire, clock.left); }
    hero.dataset.playing = String(st.playing);
    const label = st.playing ? tr('pause_tour', 'Pause the room tour') : tr('play_tour', 'Play the room tour');
    $('toggleText').textContent = label;
    toggle.title = st.playing ? tr('pause', 'Pause') : tr('play', 'Play');
  }
  let manualTimer = null;
  function manualHold() {
    st.held.add('manual'); syncHold();
    clearTimeout(manualTimer);
    manualTimer = setTimeout(() => {
      st.held.delete('manual');
      if (st.playing && !clock.fn && !st.pending) after(600, resumeTour);
      syncHold();
    }, T.manualHold);
  }
  // Resume where the tour really is: a group that has not had its swap yet gets it before moving on.
  function resumeTour() { if (st.pending) return; const s = scene(); if (st.swapped.has(st.group[s.id])) tourNext(); else tourQueue(); }
  // Hover holds start only on real pointer movement (not when the picker slides under a resting cursor)
  // and are dropped whenever their elements are rebuilt, so a removed element can never keep the tour frozen.
  function holdWhile(el, key) {
    el.addEventListener('pointermove', e => { if (e.pointerType !== 'touch' && (e.movementX || e.movementY) && !st.held.has(key)) { st.held.add(key); syncHold(); } });
    el.addEventListener('pointerleave', e => { if (e.pointerType !== 'touch' && st.held.delete(key)) syncHold(); });
  }
  function dropHolds(prefix) { let ch = false; for (const k of [...st.held]) if (k.startsWith(prefix)) { st.held.delete(k); ch = true; } if (ch) syncHold(); }

  /* ------------------------------------------------------------ images */
  const loads = new Map();
  function load(src) {
    if (!src) return Promise.resolve(null);
    if (!loads.has(src)) {
      loads.set(src, new Promise(resolve => {
        const img = new Image(); img.decoding = 'async'; img.src = src;
        // [Claude 2026-10-17] a failed download is not cached as loaded: resolve null and let a later request retry
        const done = () => { if (img.naturalWidth) resolve(img); else { loads.delete(src); resolve(null); } };
        if (img.decode) img.decode().then(done, done); else { img.onload = done; img.onerror = done; }
      }));
    }
    return loads.get(src);
  }
  const layerKey = (s, layer) => layer.groups.map(g => st.sel[s.id][g]).join('|');
  const spriteFor = (s, layer) => layer.sprites[layerKey(s, layer)] || null;
  function preloadRoom(s) {
    return Promise.all([load(modelGeometryFor(s)?.canvas || s.canvas), ...s.layers.map(l => load(spriteFor(s, l)?.src))]);
  }
  // Once a room is up (pre-launch review 9/30): while the browser is idle, fetch every picker thumbnail of this room and
  // the next room's picture, so the first tap and the first room change do not wait on the network. Skipped on Save-Data.
  function warmIdle(i) {
    if (navigator.connection && navigator.connection.saveData) return;
    const idle = window.requestIdleCallback || (fn => setTimeout(fn, 1200));
    idle(() => {
      const s = scenes[i];
      s.groups.forEach(g => g.choices.forEach(key => load(P[key].thumb)));
      const n = scenes[(i + 1) % scenes.length];
      load(n.canvas);
      new Set([planOf(n, st.visits[n.id] + 1)[0], st.group[n.id]]).forEach(gid => groupOf(n, gid)?.choices.forEach(key => load(P[key].thumb)));   // [Claude 2026-10-19]
    });
  }
  function warmAlternatives(s, gid) {
    const g = groupOf(s, gid);
    g.choices.forEach(key => {
      load(P[key].thumb);
      const geometry = s.modelGeometry?.[gid]?.[key]; if (geometry?.canvas) load(geometry.canvas);
      const sel = {...st.sel[s.id], [gid]: key};
      s.layers.filter(l => l.groups.includes(gid)).forEach(l => load(l.sprites[l.groups.map(x => sel[x]).join('|')]?.src));
    });
  }

  /* ------------------------------------------------------------ geometry */
  const unionBox = (s, gid) => { const g = groupOf(s, gid); return g.choices.map(c => g.bbox[c]).reduce(union); };
  // Only the part of the stage inside the viewport counts (laptop browsers leave ~610-660 px of height).
  function visibleStageHeight() {
    const H = stage.clientHeight;
    if (mqPhone.matches) return H;
    const top = stage.getBoundingClientRect().top + scrollY;
    return Math.max(Math.min(H, 300), Math.min(H, innerHeight - top));
  }
  // [Claude 2026-09-30] boss: the room bar sits on the photo (desktop). Its height is a band nothing else may use:
  // the fixture in focus is framed below it, and the headline, picker, room button and dots start under it.
  const roomsEl = $('rooms');
  function topInset() {
    if (mqPhone.matches) return 0;
    return Math.max(0, Math.round(roomsEl.getBoundingClientRect().bottom - stage.getBoundingClientRect().top));
  }
  // Only reviewed per-model geometry may opt into a taller scene. Legacy coordinates stay 1672×941.
  const modelGeometryFor = s => {
    if (!s.modelGeometry) return null;
    for (const gid of Object.keys(s.modelGeometry)) {
      const geometry = s.modelGeometry[gid][st.sel[s.id][gid]];
      if (geometry && Number.isFinite(geometry.height) && geometry.height >= SH) return geometry;
    }
    return null;
  };
  const stateGeometry = s => s === scene() ? modelGeometryFor(s) : null;
  const cameraBox = (s, g) => {
    const key = st.sel[s.id][g.id], geometry = stateGeometry(s);
    return geometry?.bboxes?.[g.id] || (s !== scene() && s.modelGeometry?.[g.id]?.[key]?.legacyBbox) || g.bbox[key];
  };
  function computeExtendedLayout(s, geometry) {
    const W = stage.clientWidth, H = stage.clientHeight, VH = visibleStageHeight(), inset = topInset();
    const phone = mqPhone.matches, worldH = geometry.height;
    const active = groupOf(s, st.group[s.id]);
    // Whole-scene SN focuses the selected product. Only the selected fixture must fit completely.
    const focusIds = geometry.canvas ? [active.id] : [active.id, ...(geometry.focusGroups || [])];
    const focus = [...new Set(focusIds)].map(id => groupOf(s, id)).filter(Boolean);
    const act = focus.map(g => cameraBox(s, g)).reduce(union);
    const shown = s.groups.map(g => cameraBox(s, g)).reduce(union);
    const dockW = (picker.offsetWidth || 276) + DOCK + 12, dockH = (picker.offsetHeight || 152) + DOCK + 12;
    const margin = 18, availableW = W - (phone ? margin : dockW) - margin;
    const note = stage.querySelector('.stage-note');
    const bottomGap = Math.max(margin, note ? note.offsetHeight + (parseFloat(getComputedStyle(note).bottom) || 0) + 8 : margin);
    // Preserve the legacy cover scale whenever the complete sink + faucet fits. Never flatten the photograph.
    const cover = Math.max(W / SW, H / worldH), legacy = Math.max(W / SW, H / SH);
    const fitScale = Math.min(availableW / Math.max(1, act[2] - act[0]),
      (VH - inset - margin - bottomGap) / Math.max(1, act[3] - act[1]));
    const k = Math.min(legacy, fitScale), rw = SW * k, rh = worldH * k;
    const axis = (size, render, lo, hi, a0, a1, u0, u1) => {
      const safeLo = lo - a0 * k, safeHi = size - hi - a1 * k;
      const coverLo = Math.min(0, size - render), coverHi = Math.max(0, size - render);
      const lower = Math.max(coverLo, safeLo), upper = Math.min(coverHi, safeHi);
      const preferred = size / 2 - (u0 + u1) / 2 * k;
      return lower <= upper ? clamp(preferred, lower, upper) : clamp(preferred, safeLo, safeHi);
    };
    const fy = axis(VH, rh, inset + margin, bottomGap, act[1], act[3], shown[1], shown[3]);
    const fx = axis(W, rw, phone ? margin : dockW, margin, act[0], act[2], phone ? act[0] : 0, phone ? act[2] : SW);
    return {W, H: VH, fullH: H, k, rw, rh, fx, fy, phone, inset, worldH, cover,
      needsBackdrop: rw < W - .01 || rh < H - .01 || !!(geometry.photoBounds && (geometry.photoBounds[0] > 0 || geometry.photoBounds[2] < SW))};
  }
  function computeLayout(s = scene()) {
    const geometry = stateGeometry(s);
    if (geometry) return computeExtendedLayout(s, geometry);
    const W = stage.clientWidth, H = stage.clientHeight, VH = visibleStageHeight(), inset = topInset();
    const k = Math.max(W / SW, H / SH), rw = SW * k, rh = SH * k;
    const phone = mqPhone.matches;
    const g = groupOf(s, st.group[s.id]);
    const act = cameraBox(s, g);
    const shown = s.groups.map(x => cameraBox(s, x)).reduce(union);   // what is in the room right now
    // Keep the fixture in focus fully visible and show as much of the others as possible; when the fixture itself
    // is larger than the view, keep its bottom (bases and rails sit there) or, horizontally, its centre.
    const fit = (size, render, lo, hi, a0, a1, u0, u1, align) => {
      const lower = Math.max(size - render, lo - a0 * k), upper = Math.min(0, size - hi - a1 * k);
      const pref = clamp(size / 2 - (u0 + u1) / 2 * k, size - render, 0);
      if (lower <= upper) return clamp(pref, lower, upper);
      const t = align === 'end' ? size - hi - a1 * k : size / 2 - (a0 + a1) / 2 * k;
      return clamp(t, size - render, 0);
    };
    const fy = fit(VH, rh, inset + 10, 14, act[1], act[3], shown[1], shown[3], 'end');
    // the docked picker (bottom-left): a fixture whose lower part would sit beside it is framed to its right
    const dockW = (picker.offsetWidth || 276) + DOCK + 12, dockH = (picker.offsetHeight || 152) + DOCK + 12;
    const besideDock = !phone && fy + act[3] * k > VH - dockH;
    const fx = fit(W, rw, besideDock ? dockW : 14, 14, act[0], act[2], phone ? act[0] : 0, phone ? act[2] : SW, 'center');
    return {W, H: VH, fullH: H, k, rw, rh, fx, fy, phone, inset};
  }
  const toScreen = (L, x, y) => [L.fx + x * L.k, L.fy + y * L.k];
  const boxToScreen = (L, b) => { const [x0, y0] = toScreen(L, b[0], b[1]); const [x1, y1] = toScreen(L, b[2], b[3]); return [x0, y0, x1, y1]; };
  const rectIn = el => { const r = el.getBoundingClientRect(), s = stage.getBoundingClientRect(); return [r.left - s.left, r.top - s.top, r.right - s.left, r.bottom - s.top]; };
  const overlap = (a, b) => Math.max(0, Math.min(a[2], b[2]) - Math.max(a[0], b[0])) * Math.max(0, Math.min(a[3], b[3]) - Math.max(a[1], b[1]));
  const inflate = (b, m) => [b[0] - m, b[1] - m, b[2] + m, b[3] + m];
  const gap = (a, b) => Math.hypot(Math.max(0, a[0] - b[2], b[0] - a[2]), Math.max(0, a[1] - b[3], b[1] - a[3]));

  function applyFrame(L, animate = true) {
    const worldH = L.worldH || SH;
    cam.dataset.worldHeight = String(worldH);
    $('lift').setAttribute('viewBox', `0 0 ${SW} ${worldH}`);
    roomEls.forEach(room => {
      const height = worldH === SH ? '' : `${SH / worldH * 100}%`;
      const canvasH = Number(room.dataset.canvasWorldHeight) || SH;
      room.querySelector('.canvas').style.height = canvasH === worldH ? '' : `${canvasH / worldH * 100}%`;
      room.querySelector('.layers').style.height = height;
    });
    const geometry = stateGeometry(scene());
    let backdrop = stage.querySelector('[data-sink-backdrop]');
    if (L.needsBackdrop && geometry?.backdrop) {
      if (!backdrop) {
        backdrop = document.createElement('div'); backdrop.dataset.sinkBackdrop = '';
        backdrop.setAttribute('aria-hidden', 'true');
        backdrop.style.cssText = 'position:absolute;inset:0;pointer-events:none;background-size:cover;background-position:center;filter:blur(24px);transform:scale(1.08)';
        stage.prepend(backdrop);
      }
      backdrop.style.backgroundImage = `url("${geometry.backdrop}")`; backdrop.hidden = false;
    } else if (backdrop) backdrop.hidden = true;
    if (!hero.classList.contains('is-live')) {
      // [Claude 2026-10-18] the first room's picture is server-rendered and shown full-bleed and centred before this
      // script runs; the first camera starts from exactly that view and glides to its framing instead of jumping
      const pic = hero.querySelector('.room.is-front .canvas');
      if (pic && pic.naturalWidth > 0 && !st.reduced) {
        frame.style.transition = 'none';
        frame.style.width = `${L.rw}px`; frame.style.height = `${L.rh}px`;
        frame.style.setProperty('--fx', `${(L.W - L.rw) / 2}px`); frame.style.setProperty('--fy', `${((L.fullH || L.H) - L.rh) / 2}px`);
        hero.classList.add('is-live'); void frame.offsetWidth;
        animate = true; st.glideUntil = performance.now() + 1100;
      } else hero.classList.add('is-live');
    }
    // while that first glide runs, a later layout (the commit, the ResizeObserver's first call on a warm cache) must
    // retarget it smoothly, not cancel it with transition:none and snap
    if (!animate && performance.now() < (st.glideUntil || 0)) animate = true;
    frame.style.transition = animate ? '' : 'none';
    frame.style.width = `${L.rw}px`; frame.style.height = `${L.rh}px`;
    frame.style.setProperty('--fx', `${L.fx}px`); frame.style.setProperty('--fy', `${L.fy}px`);
    frame.style.setProperty('--k', String(L.k));
    if (!animate) { void frame.offsetWidth; frame.style.transition = ''; }
  }

  function productBoxes(L, s) {
    return s.groups.map(g => ({id: g.id, box: boxToScreen(L, cameraBox(s, g))}));
  }

  // The headline is pinned to the stage (it does not ride the camera). One size per viewport for all three rooms:
  // the largest size that keeps it off every fixture in every room; at the smallest size it may narrow (three lines)
  // or step right of a fixture that starts on its left.
  function copyPlan(L, s, maxSize) {
    const boxes = productBoxes(L, s).map(p => inflate(p.box, 12));
    let [ax] = toScreen(L, s.copy.x, 0);
    let size = Math.min(maxSize, Math.round(clamp(Math.min(L.W / 29, L.H / 11), 30, 50))), fixedW = 0, left = 28;
    for (let i = 0; i < 16; i++) {
      const width = fixedW || Math.ceil(size * 12.4);
      left = Math.round(clamp(ax, 28, L.W - width - 28));
      const top = (L.inset || 0) + 26, r = [left, top, left + width, top + 27 + (fixedW ? 3 : 2) * size * 1.02];
      const hit = boxes.find(b => overlap(r, b) > 0);
      if (!hit) break;
      if (size > 30) { size = Math.max(30, size - 3); continue; }
      if (hit[0] > left) { const w = Math.floor(hit[0] - left); if (w >= 220 && w < width) { fixedW = w; continue; } }
      else if (L.W - 28 - hit[2] >= 220 && left < hit[2]) { ax = hit[2]; fixedW = Math.min(width, Math.floor(L.W - 28 - hit[2])); continue; }
      break;
    }
    return {size, width: fixedW || Math.ceil(size * 12.4), left};
  }
  // [Claude 2026-10-20] phones (boss approved 10/20 after the preview): the headline sits in the page flow above the room bar, photo and picker. The three rooms'
  // headlines wrap to different line counts in fr / de / es, which moved everything below by a line at every room change
  // (CLS 0.23); reserve the tallest of the three so the hero below the headline stays put.
  let headlineKey = '';
  function reserveHeadline(on) {
    const h1 = copy.querySelector('h1');
    if (!on) { if (headlineKey) { h1.style.minHeight = ''; headlineKey = ''; } return; }
    const key = `${h1.clientWidth}|${getComputedStyle(h1).fontSize}`;
    if (key === headlineKey) return;
    headlineKey = key;
    const probe = document.createElement('h1');
    probe.setAttribute('aria-hidden', 'true');
    probe.style.cssText = `position:absolute;visibility:hidden;pointer-events:none;left:0;top:0;width:${h1.clientWidth}px;min-height:0`;
    copy.append(probe);
    let tallest = 0;
    scenes.forEach(x => { probe.innerHTML = tr(headlineKeys[x.id], headlineFallbacks[x.id]); tallest = Math.max(tallest, probe.offsetHeight); });
    probe.remove();
    h1.style.minHeight = `${tallest}px`;
  }
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => { headlineKey = ''; if (st.layout) layout({animate: false, animatePicker: false}); });
  function placeCopy(L, s) {
    if (L.phone) { copy.style.removeProperty('--cx'); veil.classList.remove('is-on'); reserveHeadline(true); return null; }
    reserveHeadline(false);
    const cap = Math.min(...scenes.map(x => copyPlan(x === s ? L : computeLayout(x), x, 50).size));
    let p = copyPlan(L, s, cap);
    if (stateGeometry(s)?.canvas) {
      const leftEdge = Math.min(...productBoxes(L, s).map(p => p.box[0]));
      p = {...p, left: 28, width: Math.min(p.width, Math.max(220, Math.floor(leftEdge - 42)))};
    }
    copy.style.setProperty('--cx', `${p.left + stage.offsetLeft}px`); copy.style.setProperty('--cy', `${(L.inset || 0) + 26}px`);
    copy.style.setProperty('--stage-top', `${stage.offsetTop}px`);
    copy.style.setProperty('--cw', `${p.width}px`); copy.style.setProperty('--h1', `${p.size}px`);
    const r = rectIn(copy);
    const vw = (r[2] - r[0]) * 1.9, vh = (r[3] - r[1]) * 2.3;
    // [Claude 2026-10-19] moved with transform, not left/top: a room change no longer counts as a layout shift (CLS)
    veil.style.transform = `translate(${r[0] + (r[2] - r[0]) / 2 - vw / 2}px, ${r[1] + (r[3] - r[1]) / 2 - vh / 2}px)`;
    veil.style.width = `${vw}px`; veil.style.height = `${vh}px`;
    veil.style.setProperty('--va', String(s.copy.veil));
    veil.classList.add('is-on');
    return r;
  }

  // [Claude 2026-10-18] the site's fixed mail / WhatsApp buttons, in stage coordinates (desktop only)
  function floatBoxes() {
    if (mqPhone.matches) return [];
    const sr = stage.getBoundingClientRect(), out = [];
    document.querySelectorAll('.skmail-float, .skwa-float').forEach(el => {
      const r = el.getBoundingClientRect();
      if (r.width < 4 || r.height < 4 || getComputedStyle(el).visibility === 'hidden') return;
      const b = [r.left - sr.left, r.top - sr.top, r.right - sr.left, r.bottom - sr.top];
      if (b[2] > 0 && b[0] < sr.width && b[3] > 0 && b[1] < sr.height) out.push(b);
    });
    return out;
  }
  function uiBoxes() {
    const out = [];
    if (!mqPhone.matches) {
      const c = rectIn(copy); if (c[2] - c[0] > 0) out.push(inflate(c, 14));
      if (!jump.hidden) out.push(inflate(rectIn(jump), 10));
      const note = stage.querySelector('.stage-note'); if (note && note.offsetWidth) out.push(inflate(rectIn(note), 8));
      if (st.layout && !st.layout.phone) out.push(inflate(dockRect(st.layout), 10));   // the docked picker
      floatBoxes().forEach(b => out.push(inflate(b, 8)));   // [Claude 2026-10-18] the site's mail / WhatsApp buttons
    }
    return out;
  }

  // [Claude 2026-09-30] boss: 「点击切换要在固定位置，不要跑来跑去」. On desktop the picker no longer follows the fixture: it is
  // docked bottom-left of the photo in every room. The camera keeps the fixture in focus clear of it (computeLayout),
  // and the hotspot dots avoid it (uiBoxes).
  function dockRect(L) {
    const pw = picker.offsetWidth || 276, ph = picker.offsetHeight || 152;
    return [DOCK, L.H - ph - DOCK, DOCK + pw, L.H - DOCK];
  }
  function placePicker(L, s) {
    if (L.phone) return;
    const r = dockRect(L);
    picker.classList.add('no-move');
    picker.style.setProperty('--px', `${r[0] + stage.offsetLeft}px`); picker.style.setProperty('--py', `${r[1] + stage.offsetTop}px`);
    st.pickerPos = {room: s.id, x: r[0], y: r[1], w: r[2] - r[0], h: r[3] - r[1]};
  }

  function placeJump(L, s) {
    if (!s.jump) { jump.hidden = true; return; }
    jump.hidden = false;
    const [x, y] = toScreen(L, s.jump.x, s.jump.y);
    const w = jump.offsetWidth || 150, h = jump.offsetHeight || 38;
    let jx = Math.max(16, Math.min(L.W - w - 16, x - w / 2));
    let jy = Math.max(16 + (L.inset || 0), Math.min(L.H - h - 16, y - h / 2));
    if (L.phone) { jx = L.W - w - 12; jy = 12; }
    jump.style.setProperty('--jx', `${jx}px`); jump.style.setProperty('--jy', `${jy}px`);
  }

  const DOT_R = 17;
  function onProduct(s, L, x, y, skip) {
    // true when the screen point sits on any fixture silhouette (glass doors excluded: they are see-through)
    const sx = (x - L.fx) / L.k, sy = (y - L.fy) / L.k;
    const pt = new DOMPoint(sx, sy);
    return [...liftRoot.querySelectorAll('.lg-hit')].some(p => {
      const gid = p.parentNode.dataset.g;
      return gid !== 'doors' && gid !== skip && p.isPointInFill(pt);
    });
  }
  function dotFree(s, L, x, y, blockers) {
    if (x < 18 || y < 18 + (L.inset || 0) || x > L.W - 18 || y > L.H - 18) return false;
    const r = [x - DOT_R, y - DOT_R, x + DOT_R, y + DOT_R];
    if (blockers.some(b => overlap(r, b))) return false;
    for (const rr of [8, 14, DOT_R + 4]) for (let a = 0; a < 16; a++) if (onProduct(s, L, x + Math.cos(a * Math.PI / 8) * rr, y + Math.sin(a * Math.PI / 8) * rr)) return false;
    return !onProduct(s, L, x, y);
  }
  function dotCandidates(b) {
    const cx = (b[0] + b[2]) / 2, cy = (b[1] + b[3]) / 2, out = [];
    for (const d of [20, 34, 50]) out.push([cx, b[1] - d], [b[2] + d, cy], [b[0] - d, cy], [b[2] + d * .7, b[1] - d * .7], [b[0] - d * .7, b[1] - d * .7], [cx, b[3] + d]);
    return out;
  }
  function placeDots(L, s) {
    const gid = st.group[s.id];
    const blockers = uiBoxes();
    // avoid the picker's destination, not the spot it is still sliding away from
    if (picker.classList.contains('is-on') && !L.phone && st.pickerPos && st.pickerPos.room === s.id) {
      const p = st.pickerPos; blockers.push(inflate([p.x, p.y, p.x + p.w, p.y + p.h], 8));
    }
    const placed = [];
    dotsEl.querySelectorAll('.dot').forEach(dot => {
      const g = groupOf(s, dot.dataset.g);
      if (!g) return;
      const rims = [...(liftOf(g.id)?.querySelectorAll('.lg-rim') || [])].map(p => p.getBBox()).filter(r => r.width > 0)
        .sort((a, c) => c.width * c.height - a.width * a.height);
      const src = rims.length ? [rims[0].x, rims[0].y, rims[0].x + rims[0].width, rims[0].y + rims[0].height] : g.bbox[st.sel[s.id][g.id]];
      const b = boxToScreen(L, src);
      const cands = dotCandidates(b);
      const vis = [Math.max(b[0], 18), Math.max(b[1], 18), Math.min(b[2], L.W - 18), Math.min(b[3], L.H - 18)];
      if (vis[2] > vis[0] && vis[3] > vis[1]) cands.push(...dotCandidates(vis));   // the part of a cropped fixture that is on screen
      const spot = cands.find(([x, y]) => dotFree(s, L, x, y, blockers.concat(placed)));
      if (spot) placed.push([spot[0] - DOT_R - 6, spot[1] - DOT_R - 6, spot[0] + DOT_R + 6, spot[1] + DOT_R + 6]);
      if (spot) { dot.style.setProperty('--dx', `${spot[0]}px`); dot.style.setProperty('--dy', `${spot[1]}px`); }
      const on = !!spot && dot.dataset.g !== gid && hero.classList.contains('dots-on');
      dot.classList.toggle('is-on', on);
      dot.tabIndex = on ? 0 : -1;
      if (on) dot.removeAttribute('aria-hidden'); else dot.setAttribute('aria-hidden', 'true');
      if (!on && dot === document.activeElement) picker.querySelector('.pk-item.is-current')?.focus({preventScroll: true});
    });
  }

  function layout(opts = {}) {
    const s = scene();
    const L = st.layout = computeLayout();
    applyFrame(L, opts.animate !== false);
    placeCopy(L, s);
    placeJump(L, s);
    placePicker(L, s, opts.animatePicker);
    placeDots(L, s);
    const g = groupOf(s, st.group[s.id]); const b = cameraBox(s, g);
    cam.style.setProperty('--ox', `${((b[0] + b[2]) / 2 / SW) * 100}%`);
    cam.style.setProperty('--oy', `${((b[1] + b[3]) / 2 / (L.worldH || SH)) * 100}%`);
  }

  /* ------------------------------------------------------------ room layers */
  const frontRoom = () => roomEls.find(r => r.classList.contains('is-front'));
  function buildRoom(el, s) {
    el.style.transform = ''; el.classList.remove('is-holding'); el.style.transition = '';
    const geometry = modelGeometryFor(s);
    el.dataset.canvasWorldHeight = String(geometry?.canvas ? geometry.height : SH);
    if (s.modelGeometry) el._committedSelection = {...st.sel[s.id]};
    el.querySelector('.canvas').src = geometry?.canvas || s.canvas;
    el.querySelector('.layers').style.display = geometry?.canvas ? 'none' : '';
    const holder = el.querySelector('.layers'); holder.replaceChildren();
    s.layers.forEach(layer => {
      const div = document.createElement('div'); div.className = 'layer'; div.dataset.layer = layer.id;
      holder.append(div);
      const sp = spriteFor(s, layer);
      if (sp) div.append(makeSprite(sp, true));
    });
  }
  const spriteKey = sp => sp.src + '\n' + (sp.mask || '');
  function makeSprite(sp, on) {
    const img = document.createElement('img');
    img.className = 'sprite' + (on ? ' is-on' : ''); img.alt = ''; img.src = sp.src; img.decoding = 'async';
    img.style.left = `${sp.x / SW * 100}%`; img.style.top = `${sp.y / SH * 100}%`;
    img.style.width = `${sp.w / SW * 100}%`; img.style.height = `${sp.h / SH * 100}%`;
    img.dataset.src = sp.src;
    img.dataset.spriteKey = spriteKey(sp);
    if (sp.mask) {
      img.style.maskImage = `url("${sp.mask}")`;
      img.style.webkitMaskImage = `url("${sp.mask}")`;
      img.style.maskSize = img.style.webkitMaskSize = '100% 100%';
      img.style.maskRepeat = img.style.webkitMaskRepeat = 'no-repeat';
    }
    return img;
  }
  // Every layer converges on the sprite of the CURRENT selection: a newer request for the same layer supersedes an
  // older one (the older one never removes anything), and all changed layers cross-fade in the same moment, old out
  // while new comes in — no double exposure, no gap where the base room shows through.
  const layerSeq = {};
  async function updateLayers(s, groupIds) {
    const front = frontRoom(), geometry = modelGeometryFor(s);
    const canvasId = `${s.id}/canvas`, canvasSeq = layerSeq[canvasId] = (layerSeq[canvasId] || 0) + 1;
    const canvasSrc = geometry?.canvas || s.canvas;
    // [Claude 2026-10-17] the room-wide counter may only cancel a request when the room PICTURE is swapped; per-layer
    // counters decide which sprite wins (a newer pick for another layer used to drop this one's swaps entirely)
    const canvasSwap = front.querySelector('.canvas').getAttribute('src') !== canvasSrc;
    if (canvasSwap) {
      const image = await load(canvasSrc);
      if (canvasSeq !== layerSeq[canvasId] || scene() !== s || front !== frontRoom() || st.pending) return {cancelled: true};
      if (!image?.naturalWidth || !image.naturalHeight) return {failedCanvas: true};
    }
    const jobs = s.layers.filter(l => l.groups.some(g => groupIds.includes(g))).map(async layer => {
      const id = `${s.id}/${layer.id}`, seq = layerSeq[id] = (layerSeq[id] || 0) + 1;
      const div = front.querySelector(`[data-layer="${layer.id}"]`);
      if (!div) return null;
      const sp = spriteFor(s, layer);
      let img = sp ? [...div.querySelectorAll('.sprite')].find(c => c.dataset.spriteKey === spriteKey(sp) && !c.classList.contains('is-leaving')) : null;
      if (sp && !img) {
        const ok = await load(sp.src);
        if (seq !== layerSeq[id]) return null;
        if (!ok) return {id, seq, failed: true};   // [Claude 2026-10-17] never switch on a broken render
        img = makeSprite(sp, false); div.append(img);
        await (img.decode ? img.decode().catch(() => {}) : Promise.resolve());
        if (seq !== layerSeq[id]) { img.remove(); return null; }
      }
      return {id, seq, div, img};
    });
    const ready = (await Promise.all(jobs)).filter(Boolean);
    if ((canvasSwap && canvasSeq !== layerSeq[canvasId]) || scene() !== s || front !== frontRoom() || st.pending) return {cancelled: true};
    if (ready.some(r => r.failed)) return {failedCanvas: true};   // choose() puts the previous selection back
    const desired = modelGeometryFor(s);
    if ((desired?.canvas || s.canvas) !== canvasSrc) return {cancelled: true};
    front.dataset.canvasWorldHeight = String(desired?.canvas ? desired.height : SH);
    if (front.querySelector('.canvas').getAttribute('src') !== canvasSrc) front.querySelector('.canvas').src = canvasSrc;
    front.querySelector('.layers').style.display = desired?.canvas ? 'none' : '';
    if (s.modelGeometry) front._committedSelection = {...st.sel[s.id]};
    if (desired?.canvas || Number(cam.dataset.worldHeight || SH) !== SH) layout({animatePicker: true});
    ready.forEach(({id, seq, div, img}) => {
      if (seq !== layerSeq[id]) return;
      // [Claude 2026-10-17] two-stage swap: the new render fades in ON TOP while the old one stays opaque, then the old
      // one fades out underneath - a symmetric cross-fade let the default product of the base picture show through
      if (img) { div.append(img); void img.offsetWidth; img.classList.add('is-on'); }
      const old = [...div.querySelectorAll('.sprite')].filter(c => c !== img && !c.classList.contains('is-leaving'));
      old.forEach(c => c.classList.add('is-leaving'));
      const leave = () => old.forEach(c => { c.classList.remove('is-on'); setTimeout(() => c.remove(), T.fade + 200); });
      if (img) setTimeout(leave, T.fade); else leave();
    });
    await wait(T.fade);
  }

  /* ------------------------------------------------------------ rim light */
  function pathsFor(s, g) {
    const key = st.sel[s.id][g.id];
    if (g.dep && g.pathBy && g.pathBy[key] && g.pathBy[key][st.sel[s.id][g.dep]]) return g.pathBy[key][st.sel[s.id][g.dep]];
    return g.paths[key];
  }
  function el(tag, attrs) { const n = document.createElementNS(NS, tag); for (const k in attrs) n.setAttribute(k, attrs[k]); return n; }
  function buildLift(s) {
    liftRoot.replaceChildren();
    dropHolds('lg-');
    // Largest first: the glass enclosure goes under the shower set and base it contains, so those stay clickable.
    const area = g => { const b = unionBox(s, g.id); return (b[2] - b[0]) * (b[3] - b[1]); };
    [...s.groups].sort((a, b) => area(b) - area(a)).forEach(g => {
      const grp = el('g', {class: 'lg', 'data-g': g.id});
      liftRoot.append(grp);
      fillLift(s, g, grp);
      grp.addEventListener('pointerenter', () => { if (st.group[s.id] !== g.id) grp.classList.add('is-peek'); });
      grp.addEventListener('pointerleave', () => grp.classList.remove('is-peek'));
      holdWhile(grp, 'lg-' + g.id);
      grp.addEventListener('click', () => { if (scene() === s && !st.pending) userFocus(g.id); });
    });
  }
  function fillLift(s, g, grp) {
    grp.replaceChildren(); grp.dataset.fxReady = 'false';
    const ds = pathsFor(s, g);
    const all = ds.join('');
    // the WebGL rim light draws from this outline's distance field (the SVG light below is its fallback)
    const key = st.sel[s.id][g.id], bk = g.dep ? st.sel[s.id][g.dep] : null;
    grp.dataset.fx = `${s.id}|${g.id}|${key}|${g.pathBy && g.pathBy[key] && bk && g.pathBy[key][bk] ? bk : ''}`;
    grp.append(el('path', {class: 'lg-hit', d: all}));
    // Light stays outside the fixture: the product itself is never washed over (thin taps, hoses, bars, matte black).
    const mid = `mask-${s.id}-${g.id}`;
    const maskHeight = (stateGeometry(s)?.height || SH) + 160;
    const mask = el('mask', {id: mid, maskUnits: 'userSpaceOnUse', x: -80, y: -80, width: SW + 160, height: maskHeight});
    mask.append(el('rect', {x: -80, y: -80, width: SW + 160, height: maskHeight, fill: '#fff'}), el('path', {d: all, fill: '#000'}));
    grp.append(mask);
    // Blur filters per group with a user-space region = this fixture's box + margin, so no halo is ever cut square.
    const b = cameraBox(s, g), M = 96;
    const defs = el('defs', {}), fid = name => `f-${s.id}-${g.id}-${name}`;
    for (const [name, sd] of [['shade', 5], ['bloom', 9], ['glow', 2.6], ['comet', 1.6]]) {
      const f = el('filter', {id: fid(name), filterUnits: 'userSpaceOnUse', x: b[0] - M, y: b[1] - M, width: b[2] - b[0] + 2 * M, height: b[3] - b[1] + 2 * M});
      f.append(el('feGaussianBlur', {stdDeviation: sd})); defs.append(f);
    }
    grp.append(defs);
    const light = el('g', {mask: `url(#${mid})`});
    for (const cls of ['lg-shade', 'lg-bloom', 'lg-glow', 'lg-rim', 'lg-comet']) {
      const name = cls.slice(3), attrs = {class: cls, pathLength: '1'};
      if (name !== 'rim') attrs.filter = `url(#${fid(name)})`;
      ds.forEach(d => light.append(el('path', {...attrs, d})));
    }
    grp.append(light);
  }
  // Refill the changed groups plus every outline that depends on another group (hotel taps are cut by the basin rim).
  function refill(s, ids) {
    const set = new Set(ids);
    s.groups.forEach(g => { if (g.pathBy && Object.keys(g.pathBy).length) set.add(g.id); });
    set.forEach(id => { const n = liftOf(id), g = groupOf(s, id); if (n && g) fillLift(s, g, n); });
  }
  const liftOf = gid => liftRoot.querySelector(`[data-g="${gid}"]`);
  function restartClass(node, cls) { node.classList.remove(cls); void node.getBBox?.(); void node.offsetWidth; node.classList.add(cls); }
  function markTrace(grp, ms, shineAt = 0) {
    const now = performance.now(), duration = st.reduced ? 0 : ms;
    grp.dataset.fxReady = 'false';
    grp.dataset.draw = String(duration); grp.dataset.t0 = String(now);
    if (shineAt) grp.dataset.s0 = String(now + shineAt); else delete grp.dataset.s0;
    const stamp = grp.dataset.t0;
    setTimeout(() => {
      if (grp.isConnected && grp.dataset.t0 === stamp) grp.classList.remove('is-tracing');
    }, duration);
  }
  function traceGroup(gid, {shine = false} = {}) {
    const grp = liftOf(gid); if (!grp) return;
    grp.classList.remove('is-fading', 'is-sweeping');
    grp.style.setProperty('--draw', `${T.draw}ms`);
    restartClass(grp, 'is-tracing');
    markTrace(grp, T.draw, shine && !st.reduced ? T.draw + 100 : 0);
    if (shine && !st.reduced) {
      const stamp = grp.dataset.t0;
      setTimeout(() => {
        if (!grp.isConnected || grp.dataset.t0 !== stamp) return;
        restartClass(grp, 'is-sweeping');
        setTimeout(() => {
          if (grp.isConnected && grp.dataset.t0 === stamp) grp.classList.remove('is-sweeping');
        }, 1100);
      }, T.draw + 100);
    }
  }
  function setActiveLift(gid) {
    liftRoot.querySelectorAll('.lg').forEach(n => { n.classList.toggle('is-active', n.dataset.g === gid); if (n.dataset.g === gid) n.classList.remove('is-peek'); });
  }
  async function scan(s, tok) {
    const tagged = [];
    for (const gid of s.tour) {
      if (tok !== st.token) break;
      if (behindDoor(s, gid)) continue;
      const grp = liftOf(gid); if (!grp) continue;
      grp.classList.add('is-scan'); tagged.push(grp); grp.style.setProperty('--draw', '820ms'); restartClass(grp, 'is-tracing'); markTrace(grp, 820);
      await wait(150);
    }
    await wait(900);
    tagged.forEach(n => n.classList.remove('is-scan'));
  }

  /* ------------------------------------------------------------ picker */
  let pkTextTimer = 0;
  function pickerItems(s, g) {
    track.replaceChildren();
    g.choices.forEach((key, i) => {
      const p = P[key];
      const b = document.createElement('button');
      b.type = 'button'; b.className = 'pk-item'; b.dataset.i = String(i); b.dataset.g = g.id; b.dataset.scene = s.id;
      b.setAttribute('aria-label', `${p.model}, ${p.material}`);
      const img = document.createElement('img'); img.src = p.thumb; img.alt = ''; img.decoding = 'async';
      b.append(img);
      b.addEventListener('click', () => {
        const s2 = scene();
        if (st.pending || b.dataset.scene !== s2.id || b.dataset.g !== st.group[s2.id]) return;   // a leftover from another room/group
        const g2 = groupOf(s2, b.dataset.g);
        manualHold(); cancelTour();
        if (g2.choices[i] !== st.sel[s2.id][g2.id]) choose(g2.id, g2.choices[i], {manual: true});
      });
      track.append(b);
    });
  }
  function layoutTrack(g, key, animate = true) {
    const n = g.choices.length, cur = g.choices.indexOf(key);
    const small = mqPhone.matches ? 66 : mqCompact.matches ? 58 : 66;   // [Claude 2026-09-30] larger tiles (boss: 「产品放大」)
    const items = [...track.querySelectorAll('.pk-item')];
    const offOf = i => { let off = i - cur; if (off > n / 2) off -= n; if (off < -n / 2) off += n; if (n % 2 === 0 && off === -n / 2) off = n / 2; return off; };
    const curItem = items.find(it => Number(it.dataset.i) === cur);
    const shift = curItem && curItem.dataset.off !== undefined ? -Number(curItem.dataset.off) : 0;
    items.forEach(item => {
      const i = Number(item.dataset.i), off = offOf(i);
      const had = item.dataset.off !== undefined, prevOff = had ? Number(item.dataset.off) : off;
      // items that slide with the strip animate; only the one that re-enters from the hidden side fades
      const wrap = had && animate && (off - prevOff) !== shift;
      item.classList.toggle('no-anim', !animate || wrap);
      const x = off * small + (off === 0 ? 0 : Math.sign(off) * 4);
      const sc = off === 0 ? 1 : Math.abs(off) === 1 ? .76 : .6;
      const op = off === 0 ? 1 : Math.abs(off) === 1 ? .92 : 0;
      item.style.setProperty('--x', `${x}px`); item.style.setProperty('--s', String(sc));
      item.style.setProperty('--o', String(wrap ? 0 : op));
      if (wrap) requestAnimationFrame(() => requestAnimationFrame(() => { item.classList.remove('no-anim'); item.style.setProperty('--o', String(op)); }));
      item.dataset.off = String(off);
      item.classList.toggle('is-current', off === 0);
      item.tabIndex = off === 0 ? 0 : -1;   // roving tab stop; ← → move between models
      item.setAttribute('aria-current', off === 0 ? 'true' : 'false');
      item.setAttribute('aria-hidden', Math.abs(off) > 1 ? 'true' : 'false');
    });
  }
  // [Claude 2026-10-19] DV-8: the ↗ never wraps onto a line of its own. Without the SMART badge it stays (no-wrap) with
  // the material's last word inside #pkMat; with the badge it stays with the badge. Spacing is unchanged.
  const pkArrow = $('pkName').querySelector('i'), pkEnd = document.createElement('span');
  pkEnd.className = 'pk-end';
  function glueArrow(p) {
    const mat = $('pkMat'), badge = $('pkBadge');
    badge.hidden = !p.smart;
    if (p.smart) { mat.textContent = p.material; pkEnd.replaceChildren(badge, pkArrow); mat.after(pkEnd); pkEnd.classList.add('is-badge'); return; }
    mat.after(badge);
    const m = /^([\s\S]*\s)(\S+)$/.exec(p.material);
    pkEnd.classList.remove('is-badge');
    pkEnd.replaceChildren(m ? m[2] : p.material, pkArrow);
    mat.replaceChildren(m ? m[1] : '', pkEnd);
  }
  function renderPickerText(s, g, swap) {
    clearTimeout(pkTextTimer);
    const apply = () => {
      if (scene() !== s || st.group[s.id] !== g.id) return;   // focus moved on in the meantime: that render wins
      const key = st.sel[s.id][g.id], p = P[key];
      $('pkCat').textContent = g.name || g.label;
      $('pkCount').textContent = `${pad(g.choices.indexOf(key) + 1)} / ${pad(g.choices.length)}`;
      $('pkModel').textContent = p.model;
      glueArrow(p);   // [Claude 2026-10-19] DV-8 (material text + SMART badge, arrow kept with the last item)
      const name = $('pkName');
      name.href = localUrl(p.url);
      name.setAttribute('aria-label', tr('product_link_label', '{{ model }} {{ title }} on sanikb.com (opens in a new tab)', {model: `${p.model} ${p.material}${p.smart ? ' ' + $('pkBadge').textContent.trim() : ''}`, title: p.title}));   // [Claude 2026-10-19] WCAG 2.5.3: name starts with the visible model + material (+ SMART)
      name.classList.remove('is-swap');
      if (st.layout && !st.layout.phone) placePicker(st.layout, s);   // [Claude 2026-10-19] height may have changed
    };
    if (swap && !st.reduced) { $('pkName').classList.add('is-swap'); pkTextTimer = setTimeout(apply, 260); } else apply();
  }
  function queue(key) {
    const s = scene(), g = groupOf(s, st.group[s.id]);
    const i = g.choices.indexOf(key);
    const item = track.querySelector(`[data-i="${i}"]`);
    if (!item || st.reduced) return;
    item.style.setProperty('--queue', `${T.swap - T.queue}ms`);
    item.classList.remove('is-queued'); void item.offsetWidth; item.classList.add('is-queued');
  }
  function showPicker(s) {
    const g = groupOf(s, st.group[s.id]);
    picker.classList.toggle('is-single', g.choices.length < 2);
    track.querySelector('.is-queued')?.classList.remove('is-queued');
    pickerItems(s, g); layoutTrack(g, st.sel[s.id][g.id], false); renderPickerText(s, g, false);
  }

  /* ------------------------------------------------------------ actions */
  async function focusGroup(gid) {
    const s = scene(), g = groupOf(s, gid); if (!g) return;
    const tok = ++st.focusToken, roomTok = st.token;
    const prevGid = st.group[s.id];
    if (prevGid !== gid) { const old = liftOf(prevGid); if (old) { old.classList.add('is-fading'); old.classList.remove('is-active'); } }
    st.group[s.id] = gid;
    hero.dataset.group = gid;
    st.tourIdx = Math.max(0, planOf(s).indexOf(gid)); st.groupClock = 0;
    if (behindDoor(s, gid)) {   // bring back the clear door so the shower set / base can be seen
      const r = D.rules[s.id]; st.sel[s.id][r.exclusive] = r.clearDoor;
      updateLayers(s, [r.exclusive]).then(() => { if (scene() === s && roomTok === st.token) refill(s, [r.exclusive]); });
    }
    showPicker(s);
    rail.querySelectorAll('button').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.g === gid)));
    {   // [Claude 2026-10-19] phones: the pressed chip is scrolled into the rail (scrollBy moves only the rail, never the page)
      const on = rail.querySelector('button[aria-pressed="true"]');
      if (on && rail.scrollWidth > rail.clientWidth + 1) {
        const rr = rail.getBoundingClientRect(), br = on.getBoundingClientRect();
        if (br.left < rr.left + 12 || br.right > rr.right - 12) rail.scrollBy({left: (br.left + br.right) / 2 - (rr.left + rr.right) / 2, behavior: st.reduced ? 'auto' : 'smooth'});
      }
    }
    layout({animatePicker: true});
    picker.classList.add('is-on');
    await wait(prevGid !== gid ? 220 : 0);
    if (tok !== st.focusToken || roomTok !== st.token || scene() !== s) return;
    liftRoot.querySelectorAll('.lg.is-fading').forEach(n => { if (n.dataset.g !== gid) n.classList.remove('is-fading'); });   // [Claude 2026-10-19] incl. a superseded focus
    setActiveLift(gid);
    traceGroup(gid);
    placeDots(st.layout, s);
    warmAlternatives(s, gid);
  }

  // v13: a layer shows one render per combination (hotel: basin|faucet of one vanity position). A combination without a
  // render puts the other product(s) of that layer back to their defaults, so every picture shown is one real render.
  function fixCombos(s, sel, keep) {
    const changed = [];
    s.layers.forEach(l => {
      if (l.groups.length < 2) return;
      const k = l.groups.map(g => sel[g]).join('|');
      if (k in l.sprites) return;
      const kept = [].concat(keep || []);
      l.groups.forEach(g => { if (!kept.includes(g)) { const d = groupOf(s, g).choices[0]; if (sel[g] !== d) { sel[g] = d; changed.push(g); } } });
      if (!(l.groups.map(g => sel[g]).join('|') in l.sprites)) l.groups.forEach(g => { const d = groupOf(s, g).choices[0]; if (sel[g] !== d) { sel[g] = d; changed.push(g); } });
    });
    return changed;
  }
  function applyRules(s, gid, key) {
    const changed = [gid, ...fixCombos(s, st.sel[s.id], gid)];
    // v12: linked groups — choosing a non-default model puts the other one back to its default (one render at a time)
    (D.rules[s.id]?.links || []).forEach(([a, b]) => {
      const other = gid === a ? b : gid === b ? a : null; if (!other) return;
      const og = groupOf(s, other);
      if (key !== groupOf(s, gid).choices[0] && st.sel[s.id][other] !== og.choices[0]) { st.sel[s.id][other] = og.choices[0]; changed.push(other); }
    });
    if (s.id === 'bath') {
      const r = D.rules.bath, sel = st.sel.bath;
      if (gid === r.exclusive && key !== r.clearDoor) {
        s.groups.forEach(g => { if (g.id !== gid && g.id !== 'tubs' && sel[g.id] !== g.choices[0]) { sel[g.id] = g.choices[0]; changed.push(g.id); } });
      } else if (gid !== r.exclusive && gid !== 'tubs' && sel[r.exclusive] !== r.clearDoor && key !== groupOf(s, gid).choices[0]) {
        sel[r.exclusive] = r.clearDoor; changed.push(r.exclusive);
      }
    }
    return changed;
  }

  async function choose(gid, key, {manual = false} = {}) {
    const s = scene(), g = groupOf(s, gid);
    if (!g || st.pending || st.sel[s.id][gid] === key) return;
    const roomTok = st.token, previousSel = {...st.sel[s.id]};
    st.sel[s.id][gid] = key;
    st.swapped.add(gid);
    const changed = applyRules(s, gid, key), applied = {...st.sel[s.id]};
    track.querySelector('.is-queued')?.classList.remove('is-queued');
    if (st.group[s.id] === gid) { layoutTrack(g, key, true); renderPickerText(s, g, true); }
    const grp = liftOf(gid);
    if (grp) grp.classList.add('is-fading');
    const outcomes = await Promise.all([updateLayers(s, changed), wait(260)]);
    if (outcomes[0]?.cancelled) return;
    if (outcomes[0]?.failedCanvas) {
      if (roomTok === st.token && scene() === s && !st.pending && st.sel[s.id][gid] === key) {
        // [Claude 2026-10-19] put back only what THIS pick changed and nobody has changed since (a newer pick elsewhere stays)
        const cur = st.sel[s.id]; changed.forEach(id => { if (cur[id] === applied[id]) cur[id] = previousSel[id]; });
        fixCombos(s, cur); refill(s, s.groups.map(x => x.id));
        if (grp) grp.classList.remove('is-fading');
        if (st.group[s.id] === gid) { layoutTrack(g, previousSel[gid], false); renderPickerText(s, g, false); setActiveLift(gid); }
        layout({animatePicker: true});
      }
      return;
    }
    if (roomTok !== st.token || scene() !== s || st.pending) return;
    if (st.sel[s.id][gid] !== key) return;   // a newer pick for this group finishes the job
    refill(s, s.groups.map(x => x.id));   // [Claude 2026-10-17] incl. groups an older, superseded pick changed (rules)
    if (grp) grp.classList.remove('is-fading');
    if (st.group[s.id] === gid) { setActiveLift(gid); traceGroup(gid, {shine: true}); }
    layout({animatePicker: true});
    if (manual) live.textContent = tr('product_selected', '{{ category }}: {{ model }}, {{ material }}, now shown in the room.', {category: g.name || g.label, model: P[key].model, material: P[key].material});
  }

  // Room requests from tabs and the jump button. Clicking the room that is still on screen while another one is loading
  // cancels that change; clicking the room that is already on its way just keeps it (and stops the tour there).
  function requestRoom(i) {
    if (st.pending && i === st.room && !st.first) { cancelPending(); manualHold(); return; }   // [Claude 2026-10-18] never cancel the first build
    if (i === st.target) { if (st.pending) st.forceManual = true; else { manualHold(); cancelTour(); } return; }
    goRoom(i, {manual: true});
  }
  function cancelPending() {
    ++st.token; st.pending = false; st.target = st.room; st.forceManual = false;
    hero.classList.remove('is-switching');
    const s = scene();
    renderTabs();
    liftRoot.querySelectorAll('.lg').forEach(n => n.classList.remove('is-fading'));
    copy.classList.remove('is-out'); roomTag.classList.remove('is-swap');
    if (s.jump) { jump.classList.add('is-on'); jump.tabIndex = 0; }
    hero.classList.add('dots-on');
    {   // [Claude 2026-10-17] a pick cut short by the room click may be half applied: always re-sync layers + outlines
      const tok = st.token, front = frontRoom(), ids = s.groups.map(g => g.id);
      updateLayers(s, ids).then(result => {
        if (tok !== st.token || scene() !== s || st.pending || result?.cancelled) return;
        if (result?.failedCanvas && front._committedSelection) st.sel[s.id] = {...front._committedSelection};
        refill(s, ids); focusGroup(st.group[s.id]);
      });
    }
  }

  async function goRoom(i, {auto = false, manual = false, focus} = {}) {
    const tok = ++st.token; cancelTour();
    const s = scenes[i];
    st.target = i; st.pending = true;
    hero.classList.add('is-switching');
    renderTabs();
    dropHolds('dot-'); dropHolds('lg-');
    if (auto) { st.visits[s.id]++; st.sel[s.id] = entryState(s, st.visits[s.id]); st.group[s.id] = planOf(s)[0]; }
    if (focus) st.group[s.id] = focus;
    picker.classList.remove('is-on');
    hero.classList.remove('dots-on');
    liftRoot.querySelectorAll('.lg').forEach(n => n.classList.add('is-fading'));
    if (!mqPhone.matches) copy.classList.add('is-out');   // phone headlines update with the committed room without a fade
    roomTag.classList.add('is-swap'); jump.classList.remove('is-on'); jump.tabIndex = -1;
    dotsEl.querySelectorAll('.dot').forEach(d => { d.tabIndex = -1; });   // [Claude 2026-10-19] dots ignore input while switching
    const roomImages = await Promise.all([preloadRoom(s), wait(st.first ? 0 : 360)]);
    if (!roomImages[0][0]?.naturalWidth && !st.first) {   // [Claude 2026-10-17] any room picture, not only the tall one
      if (tok === st.token) { cancelPending(); if (auto && st.playing) after(T.next, tourNext); }
      return;
    }
    if (tok !== st.token) return;
    // [Claude 2026-10-19] an entry render that failed to download: show that layer's default models (in the room picture)
    s.layers.forEach((l, j) => { if (spriteFor(s, l) && !roomImages[0][j + 1]) l.groups.forEach(g => { st.sel[s.id][g] = groupOf(s, g).choices[0]; }); });
    const front = frontRoom(), back = roomEls.find(r => r !== front);
    buildRoom(back, s);
    await load(s.canvas);
    if (tok !== st.token) return;
    const prevL = st.layout;
    st.room = i; st.pending = false; st.swapped = new Set();
    hero.dataset.room = s.id; hero.classList.remove('is-switching');
    buildLift(s);
    const refocus = [dotsEl, rail, track].some(n => n.contains(document.activeElement));   // [Claude 2026-10-19] rebuilt below
    renderTabs(); renderRail(s); renderDots(s);
    roomTag.textContent = s.tag;
    copy.querySelector('h1').innerHTML = tr(headlineKeys[s.id], headlineFallbacks[s.id]);
    showPicker(s);   // phones show the picker all the time: it must belong to the new room at once
    if (refocus) tabsEl.querySelector('.room-tab[aria-current="true"]')?.focus({preventScroll: true});   // [Claude 2026-10-19]
    if (!s.jump && document.activeElement === jump) tabsEl.querySelector('[aria-current="true"]')?.focus({preventScroll: true});   // [Claude 2026-10-19]
    layout({animate: st.first && i === 0 && !st.reduced && front.querySelector('.canvas').naturalWidth > 0});   // [Claude 2026-10-18] keep the first glide
    // The frame now carries the new camera (and the arrival zoom); hold the outgoing picture exactly where it was
    // while it fades out: offset by the camera delta and counter-scaled against the zoom.
    if (prevL && !st.first) {
      front.style.setProperty('--hx', `${prevL.fx - st.layout.fx}px`); front.style.setProperty('--hy', `${prevL.fy - st.layout.fy}px`);
      if (st.reduced) front.style.transform = 'translate(var(--hx), var(--hy))'; else front.classList.add('is-holding');
    }
    // [Claude 2026-10-18] server picture on screen (room 0 only): the entry models fade in ON TOP of it while it stays
    // opaque underneath (a symmetric cross-fade of two copies of one picture dims / washes it out), and no arrival zoom
    const ssr = st.first && i === 0 && front.querySelector('.canvas').naturalWidth > 0;
    if (st.first && !ssr) { back.style.transition = 'none'; front.style.transition = 'none'; }
    if (ssr) front.style.transition = 'opacity 0s linear 1.1s';
    back.classList.add('is-front'); front.classList.remove('is-front');
    if (st.first) { void back.offsetWidth; back.style.transition = ''; if (!ssr) front.style.transition = ''; st.first = false; }
    warmIdle(i);
    cam.classList.remove('is-settling'); void cam.offsetWidth; if (!st.reduced && !ssr) cam.classList.add('is-settling');
    st.tourIdx = Math.max(0, planOf(s).indexOf(st.group[s.id])); st.groupClock = 0;
    await wait(420);
    if (tok !== st.token) return;
    copy.classList.remove('is-out'); roomTag.classList.remove('is-swap');
    if (s.jump) { jump.classList.add('is-on'); jump.tabIndex = 0; }
    await wait(T.entryScan - 420);
    if (tok !== st.token) return;
    await scan(s, tok);
    if (tok !== st.token) return;
    hero.classList.add('dots-on');
    await focusGroup(st.group[s.id]);
    if (tok !== st.token) return;
    const m = manual || st.forceManual; st.forceManual = false;
    if (!m && st.playing) after(T.queue, tourQueue);
    else if (m) manualHold();
  }

  /* ------------------------------------------------------------ tour */
  function tourQueue() {
    if (st.pending) return;
    const s = scene(), g = groupOf(s, st.group[s.id]);
    if (g.choices.length < 2) { st.swapped.add(g.id); after(T.next - T.queue, tourNext); return; }   // one model: show it, no swap
    const key = nextChoice(s, g);
    queue(key);
    // [Claude 2026-10-17] slow connections: swap only once the render is in memory (at most 6 s more), so the label, the
    // outline and the picture change together and a short room visit does not end before its swap is seen
    after(T.swap - T.queue, function swap() {
      const gen = st.tourGen || 0;
      Promise.race([preloadPick(s, g.id, key), wait(6000)]).then(() => {
        if (gen !== (st.tourGen || 0) || st.pending || scene() !== s || st.group[s.id] !== g.id) return;
        if (held()) { after(0, swap); return; }   // paused / hovered meanwhile: carry on when the hold ends
        choose(g.id, key);
        after(T.next - T.swap, tourNext);
      });
    });
  }
  function preloadPick(s, gid, key) {
    const sel = {...st.sel[s.id], [gid]: key};
    return Promise.all(s.layers.filter(l => l.groups.includes(gid)).map(l => load(l.sprites[l.groups.map(x => sel[x]).join('|')]?.src)));
  }
  function tourNext() {
    if (st.pending) return;
    const s = scene(), plan = planOf(s);
    const i = plan.indexOf(st.group[s.id]);
    // [Claude 2026-10-19] after a manual visit the focused group may be outside this visit's plan: carry on with the plan
    // (its first group not yet swapped) and leave the room only once the whole plan has been shown
    const nextGid = i >= 0 ? plan[i + 1] : plan.find(g => !st.swapped.has(g));
    if (nextGid) {
      focusGroup(nextGid);
      after(T.queue, tourQueue);
    } else {
      goRoom((st.room + 1) % scenes.length, {auto: true});
    }
  }

  /* ------------------------------------------------------------ user input */
  function userFocus(gid) {
    if (st.pending) return;
    manualHold(); cancelTour();
    focusGroup(gid);
  }
  function renderTabs() {
    if (!tabsEl.children.length) {
      scenes.forEach((s, i) => {
        const b = document.createElement('button');
        b.type = 'button'; b.className = 'room-tab'; b.dataset.i = String(i);
        b.innerHTML = `<b>${pad(i + 1)}</b><span></span><span class="prog" aria-hidden="true"><i></i></span>`;
        b.querySelector('span').textContent = s.name;
        b.addEventListener('click', () => requestRoom(i));
        tabsEl.append(b);
      });
    }
    tabsEl.querySelectorAll('.room-tab').forEach(b => {
      const on = Number(b.dataset.i) === st.target;
      b.setAttribute('aria-current', on ? 'true' : 'false');
      if (!on) b.querySelector('.prog i').style.setProperty('--p', '0');
    });
  }
  function renderRail(s) {
    rail.replaceChildren(); rail.scrollLeft = 0;   // [Claude 2026-10-19] a new room's chips start at the rail's start
    s.tour.forEach(gid => {
      const g = groupOf(s, gid);
      const b = document.createElement('button');
      b.type = 'button'; b.dataset.g = gid; b.textContent = g.name || g.label;
      b.setAttribute('aria-pressed', String(gid === st.group[s.id]));
      b.addEventListener('click', () => userFocus(gid));
      b.addEventListener('focus', () => { if (b.matches(':focus-visible')) b.scrollIntoView({block: 'nearest', inline: 'nearest'}); });   // [Claude 2026-10-19] keyboard
      rail.append(b);
    });
  }
  function renderDots(s) {
    dropHolds('dot-');
    dotsEl.replaceChildren();
    s.tour.forEach(gid => {
      const g = groupOf(s, gid);
      const b = document.createElement('button');
      b.type = 'button'; b.className = 'dot'; b.dataset.g = gid; b.tabIndex = -1; b.setAttribute('aria-hidden', 'true');
      const de = /^de\b/i.test(I.locale || ''), cat = (g.name || g.label).split(' ').map(w => de || /^\p{Lu}{2,}$/u.test(w) ? w : w.toLowerCase()).join(' ');   // [Claude 2026-10-19] German nouns, WC
      b.setAttribute('aria-label', tr('show_product', 'Show the {{ category }} in this room', {category: cat}));
      const tip = document.createElement('span'); tip.className = 'dot-tip'; tip.textContent = g.name || g.label; b.append(tip);
      b.addEventListener('click', () => userFocus(gid));
      b.addEventListener('pointerenter', () => liftOf(gid)?.classList.add('is-peek'));
      b.addEventListener('pointerleave', () => liftOf(gid)?.classList.remove('is-peek'));
      holdWhile(b, 'dot-' + gid);
      dotsEl.append(b);
    });
  }

  $('pkPrev').addEventListener('click', () => step(-1));
  $('pkNext').addEventListener('click', () => step(1));
  function step(d) {
    if (st.pending) return;
    const s = scene(), g = groupOf(s, st.group[s.id]);
    const n = g.choices.length, i = g.choices.indexOf(st.sel[s.id][g.id]);
    manualHold(); cancelTour();
    choose(g.id, g.choices[(i + d + n) % n], {manual: true});
  }
  picker.addEventListener('keydown', e => {
    if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
    e.preventDefault(); step(e.key === 'ArrowLeft' ? -1 : 1);
    if (track.contains(document.activeElement)) track.querySelector('.pk-item.is-current')?.focus({preventScroll: true});   // focus follows the model
  });
  jump.addEventListener('click', () => {
    const i = scenes.findIndex(s => s.id === scene().jump?.to); if (i < 0) return;
    if (jump.matches(':focus-visible')) tabsEl.querySelector(`.room-tab[data-i="${i}"]`)?.focus({preventScroll: true});   // [Claude 2026-10-19] keyboard
    requestRoom(i);
  });
  toggle.addEventListener('click', () => {
    st.playing = !st.playing;
    if (st.playing) { st.held.delete('manual'); st.held.delete('focus'); clearTimeout(manualTimer); if (!clock.fn && !st.pending) after(500, resumeTour); }
    syncHold();
  });
  // Scene tabs use the timed manual hold; a parked pointer must not freeze the tour.
  holdWhile(picker, 'picker'); holdWhile(jump, 'jump');
  // [Claude 2026-10-19] the Pause/Play button itself does not hold the tour: pressing Play must play even while it has focus
  hero.addEventListener('focusin', e => { if (e.target !== toggle && e.target.matches(':focus-visible')) { st.held.add('focus'); syncHold(); } });
  hero.addEventListener('focusout', e => { if (!hero.contains(e.relatedTarget)) { st.held.delete('focus'); syncHold(); } });
  document.addEventListener('visibilitychange', syncHold);
  // [Claude 2026-10-19] a11y-12: Escape hides a hotspot tooltip (WCAG 1.4.13); the next hover or focus shows tooltips again
  document.addEventListener('keydown', e => { if (e.key === 'Escape' && dotsEl.querySelector('.dot:hover, .dot:focus-visible')) dotsEl.classList.add('tips-off'); });
  dotsEl.addEventListener('focusin', () => dotsEl.classList.remove('tips-off'));
  dotsEl.addEventListener('pointerover', e => { if (e.target.closest('.dot') && !e.target.closest('.dot').contains(e.relatedTarget)) dotsEl.classList.remove('tips-off'); });
  if ('IntersectionObserver' in window) new IntersectionObserver(es => { const e = es[es.length - 1]; st.inView = e.isIntersecting; hero.classList.toggle('is-away', !e.isIntersecting); syncHold(); }, {threshold: 0.25}).observe(hero);   // [Claude 2026-10-18] is-away: css pauses endless animations
  const onReduce = e => { st.reduced = e.matches; if (e.matches) { st.playing = false; syncHold(); } };
  mqReduce.addEventListener ? mqReduce.addEventListener('change', onReduce) : mqReduce.addListener(onReduce);
  let rz = 0;
  const onResize = () => { cancelAnimationFrame(rz); rz = requestAnimationFrame(() => layout({animate: false, animatePicker: false})); };
  addEventListener('resize', onResize, {passive: true});
  // [Claude 2026-10-19] tablet rotation / window resize across 900 or 1180 px: the strip's spacing follows at once
  const onBreak = () => { const s = scene(), g = groupOf(s, st.group[s.id]); if (g && track.children.length) layoutTrack(g, st.sel[s.id][g.id], false); };
  [mqPhone, mqCompact].forEach(m => m.addEventListener ? m.addEventListener('change', onBreak) : m.addListener(onBreak));
  if ('ResizeObserver' in window) new ResizeObserver(onResize).observe(stage);

  // Room progress on the active tab = the tour's real position (group index + time in the current group);
  // it only advances while the tour clock is running, and a long frame gap (hidden tab) counts as one frame.
  let lastT = performance.now();
  (function tick(t) {
    const dt = Math.min(100, Math.max(0, t - lastT)); lastT = t;
    const s = scene();
    if (!held() && st.playing && clock.fn && !st.pending) st.groupClock += dt;
    const p = st.pending ? 0 : Math.min(1, (st.tourIdx + Math.min(1, st.groupClock / T.next)) / planOf(s).length);
    const bar = tabsEl.querySelector('[aria-current="true"] .prog i');
    if (bar) bar.style.setProperty('--p', String(p));
    // [Claude 2026-10-18] idle cost: the bar only moves while the tour clock runs; otherwise check 4 times a second
    if (!held() && st.playing && clock.fn && !st.pending) requestAnimationFrame(tick);
    else setTimeout(() => requestAnimationFrame(tick), 250);
  })(lastT);

  // QA hook (read-only snapshot for the headless checks in tools/).
  window.__heroV9 = () => ({room: scene().id, group: st.group[scene().id], sel: {...st.sel[scene().id]}, playing: st.playing,
    held: [...st.held], pending: st.pending, target: scenes[st.target].id,
    layout: st.layout && {k: st.layout.k, fx: st.layout.fx, fy: st.layout.fy, W: st.layout.W, H: st.layout.H},
    picker: picker.classList.contains('is-on') ? rectIn(picker) : null, copy: rectIn(copy),
    boxes: st.layout ? productBoxes(st.layout, scene()) : []});

  syncHold();
  goRoom(0, {auto: true});
})();
